import { REQUEST_HUMAN_APPROVAL_TOOL_NAME } from '../../../contracts/projects/approval-tool-names';

import { EMAIL_SESSION_CONTENT_TOOL_NAME } from './ApprovalRequestBlock.multiplayer';

/**
 * Per-tool opt-in for the free-text note on an approval card. The note posts as
 * `reason`, steers the agent's next step and persists in the approval history,
 * so it is offered only where there is something to steer:
 *
 *   * `request_human_approval` — the agent asked a question; the note is the answer.
 *   * `email_session_content` — outbound content the clinician may want to direct.
 *
 * A yes/no gate (delete, unshare, merge, confirm a code) has nothing to steer, and
 * an unregistered tool has no known semantics — both render no note box.
 */
const APPROVAL_NOTE_TOOL_NAMES: ReadonlySet<string> = new Set([
  REQUEST_HUMAN_APPROVAL_TOOL_NAME,
  EMAIL_SESSION_CONTENT_TOOL_NAME,
]);

export const approvalAcceptsNote = (toolName: string): boolean =>
  APPROVAL_NOTE_TOOL_NAMES.has(toolName);
